export default __webpack_public_path__ + "static/media/obstacles.21be5aa6.svg";